import { render, staticRenderFns } from "./reviewTextPlan.vue?vue&type=template&id=5485b70e&scoped=true"
import script from "./reviewTextPlan.vue?vue&type=script&lang=js"
export * from "./reviewTextPlan.vue?vue&type=script&lang=js"
import style0 from "./reviewTextPlan.vue?vue&type=style&index=0&id=5485b70e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485b70e",
  null
  
)

export default component.exports